// extracted by mini-css-extract-plugin
module.exports = {"root":"Toggle_root__NE8lC","indicator":"Toggle_indicator__bznZN","leftLabel":"Toggle_leftLabel__AnkGy","rightLabel":"Toggle_rightLabel__e5TDk"};